import SelectedGroup from '../pages/assignments/group-members/SelectedGroup';
import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { GroupsList } from '../pages/assignments/groups/GroupsList';
import { useAssignmentGroups } from '../pages/assignments/members/useAssignmentGroups';
import { useRoutingContext } from './RoutingContext';
import { useEffect } from 'react';
import useQueryParams from '../../navigation-utils/useQueryParams';

export enum AssignmentGroupsQueryParams {
  groupId = 'groupId',
}

const useLoadGroupFromDeepLink = () => {
  const { setSelectedGroupId } = useRoutingContext();

  const query = useQueryParams();

  useEffect(() => {
    const groupId = query.get(AssignmentGroupsQueryParams.groupId);
    if (groupId) {
      setSelectedGroupId(groupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const Groups = ({
  onClose,
  isDialogLayout,
}: {
  onClose?: () => void;
  isDialogLayout?: boolean;
}) => {
  const { selectedGroupId, setSelectedGroupId } = useRoutingContext();
  const { assignmentGroups } = useAssignmentGroups();
  useLoadGroupFromDeepLink();

  return (
    <>
      {!assignmentGroups && <CenteredCircularProgress />}
      {assignmentGroups && (
        <>
          {selectedGroupId ? (
            <SelectedGroup
              groupId={selectedGroupId}
              onBackClick={() => setSelectedGroupId('')}
              onClose={onClose}
              isDialogLayout={isDialogLayout}
            />
          ) : (
            <GroupsList
              assignmentsGroupList={assignmentGroups}
              onGroupClick={setSelectedGroupId}
              onClose={onClose}
              isDialogLayout={isDialogLayout}
            />
          )}
        </>
      )}
    </>
  );
};

export default Groups;
